export default "__VITE_ASSET__CwLVoJK4__"